import { render } from "./RegisterSidebar.vue?vue&type=template&id=75b1aa0f&scoped=true"
import script from "./RegisterSidebar.vue?vue&type=script&lang=js"
export * from "./RegisterSidebar.vue?vue&type=script&lang=js"

import "./RegisterSidebar.vue?vue&type=style&index=0&id=75b1aa0f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b1aa0f"]])

export default __exports__